import Vue from 'vue'

import d2Container from './d2-container'

import iconIcomoon from './icon-icomoon'

// 注意 有些组件使用异步加载会有影响

Vue.component('d2-container', d2Container)
Vue.component('d2-page-cover', () => import('./d2-page-cover'))
Vue.component('d2-icon', () => import('./d2-icon'))
Vue.component('d2-icon-svg', () => import('./d2-icon-svg/index.vue'))
Vue.component('icon-icomoon', iconIcomoon)
// anva通用组件
Vue.component('anva-copyright', () => import('./anva-common/anva-copyright'))
// appstore应用商店通用组件
Vue.component('appstore-copyright', () => import('./appstore-common/appstore-copyright'))
